import React from 'react';
import PropTypes from 'prop-types';

import { colors } from '../../../common/styles/style-constants';

const ResumeFunnel = ({ color }) => (
  <svg
    width="47"
    height="42"
    viewBox="0 0 47 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.5 0.449219C21.8008 0.449219 20.4004 1.64842 20.0508 3.25002H17.25C16.9003 1.65042 15.5 0.449219 13.8008 0.449219C12.1016 0.449219 10.7011 1.64842 10.3516 3.25002H7.5C7.15039 1.65042 5.75 0.449219 4.0508 0.449219C2.09965 0.449219 0.5 2.05077 0.5 4.00002C0.5 5.94927 2.0996 7.55082 4.0508 7.55082C5.75 7.55082 7.1504 6.35162 7.5 4.75002H10.3008C10.6504 6.34962 12.0508 7.55082 13.75 7.55082C15.4492 7.55082 16.8496 6.35162 17.1992 4.75002H20C20.3496 6.34962 21.75 7.55082 23.4492 7.55082C25.3984 7.55082 27 5.95122 27 4.00002C27.0508 2.05082 25.4492 0.449219 23.5 0.449219H23.5Z"
      fill={color}
    />
    <path
      d="M33.25 0.449219C31.3008 0.449219 29.6992 2.04882 29.6992 4.00002C29.6992 5.94922 31.2988 7.55082 33.25 7.55082C35.1992 7.55082 36.8008 5.95122 36.8008 4.00002C36.75 2.05082 35.1993 0.449219 33.25 0.449219ZM33.25 7.05072C31.5508 7.05072 30.1992 5.70112 30.1992 3.99992C30.1992 2.30072 31.5488 0.94912 33.25 0.94912C34.9492 0.94912 36.3008 2.29872 36.3008 3.99992C36.3008 5.69912 34.9004 7.05072 33.25 7.05072Z"
      fill={color}
    />
    <path
      d="M42.9492 0.449219C41 0.449219 39.3984 2.04882 39.3984 4.00002C39.3984 5.94922 40.998 7.55082 42.9492 7.55082C44.8984 7.55082 46.5 5.95122 46.5 4.00002C46.5 2.05082 44.9004 0.449219 42.9492 0.449219ZM42.9492 7.05072C41.25 7.05072 39.8984 5.70112 39.8984 3.99992C39.8984 2.30072 41.248 0.94912 42.9492 0.94912C44.6504 0.94912 46 2.30067 46 3.99992C46 5.69917 44.6504 7.05072 42.9492 7.05072Z"
      fill={color}
    />
  </svg>
);

ResumeFunnel.defaultProps = {
  color: colors.blue,
};

ResumeFunnel.propTypes = {
  color: PropTypes.string,
};

export default ResumeFunnel;
